module.exports = __webpack_public_path__ + "images/for_company_page/media_techwave_2aa661faee30565887c7a25c8df7f303.png";